import { SVG, SVGProps } from './svg'

export function IconToolMeasure(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path d="M4 11.5c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5h24c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5H4zm2.5 1V14a.5.5 0 001 0v-1.5h2V16a.5.5 0 001 0v-3.5h2V14a.5.5 0 001 0v-1.5h2V16a.5.5 0 001 0v-3.5h2V14a.5.5 0 001 0v-1.5h2V16a.5.5 0 001 0v-3.5h2V14a.5.5 0 001 0v-1.5h2v7h-23v-7h2z" />
    </SVG>
  )
}
